import { BaseQueryKeys } from '@amzn/gsce-shared-react-lib';

/**
 * Query key constants for category reference-data queries.
 *
 * Extends the shared lib's BaseQueryKeys pattern — createQuery auto-maps
 * request params into the cache key as [collectionName, params].
 */
export class CategoryQueryKeys extends BaseQueryKeys {
  /** Matches all category-list queries. */
  static readonly list = 'category-list' as const;
}
